import React, { Component } from 'react'
import EntityList from './../../components/entityList';
import TrailerEdit from './trailerEdit';

import utils from '../../misc/utils';
var config = utils.getConfig();

class Trailers extends Component {
  constructor(props, context) {
    super(props, context);

    this.afterSave = this.afterSave.bind(this);

    this.state = {};
  }

  afterSave(id, cloneEntity, currentEntity, successCallback){
    if(cloneEntity.Images){
      cloneEntity.Images.map((image, i) => {
        image.Sequence = i;

        if(image.State){
          switch(image.State){
            case 'added': 
              image.ExID = id;
              utils.postDataToApi('api/trailers/' + id + '/images', image, null, null);
            break;
            case 'deleted':
              if(Number.isInteger(image.ID)){
                utils.deleteFromApri('api/trailers/' + id + '/images/' + image.ID, null, null);
              }
            break;
          }
        }
        else{
          if(Number.isInteger(image.ID)){
            utils.putDataToApi('api/trailers/' + id + '/images/' + image.ID, image, null);
          }
        }
      });
    }
    
    successCallback();
  }  

  render() {
    return (
      <EntityList apiRoute='api/trailers' baseCriteria={'count=1000&scope=' + (this.state.scope ? this.state.scope : 'active')} editComponent={TrailerEdit} title='Remorques' editTitle='Remorque' afterSave={this.afterSave} displayColumns={[
        {Description: 'No. inventaire', Column: 'ProductNumber'},
        {Description: 'No. modèle', Column: 'ModelNumber'},
        {Description: 'Modèle', Column: 'TrailerModel', format: {type: 'relation', displayColumn: 'Description'}},
        {Description: 'État', Column: 'State', format: {type: 'relation', displayColumn: 'Description'}},        
        {Description: 'Marque', Column: 'Make', format: {type: 'relation', displayColumn: 'Description'}},
        {Description: 'Année', Column: 'Year'},        
        {Description: 'Prix', Column: 'Price', format: {type: 'money'}},        
      ]}/>
    )
  }
}

export default Trailers;



/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/trailers.js
 **/